<payee-chip-dropdown
  [placeholder]="'Adószám'"
  [selected]="control.value"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="control.patchValue(null)"
>
  <payee-form-field width="wide">
    <span payee-label>Adószám</span>
    <input
      payee-input
      [formControl]="control"
      (paste)="closeAfterPaste()"
    />
  </payee-form-field>
</payee-chip-dropdown>
